<template>
  <div class="box">
    <img :src="pageInfo.topImg" alt="" class="topImg" v-if="pageInfo" />
    <!-- <div class="navTitle" v-if="pageInfo">{{ pageInfo.bannerTitle }}</div> -->
    <div class="navbar" v-if="pageInfo && pageInfo.secondModuleDtoList.length > 0">
      <span class="navBarTitle">重点帮促县（区）：</span>
      <div class="navItemBox">
        <template v-for="(item, index) in pageInfo.secondModuleDtoList">
          <span :class="['navItem', index == chooseIndex ? 'active' : '']" @click="
              changeIndex(index, 'secondModuleDtoList');
              chooseIndex = index;
            ">{{ item.moduleTitle }}</span>
          <span class="line" v-if="index != pageInfo.secondModuleDtoList.length - 1"></span>
        </template>
      </div>
    </div>
    <div class="navbar" v-if="pageInfo && pageInfo.secondPovertyModuleDtoList.length > 0">
      <span class="navBarTitle" style="margin-right:64px">其他地区：</span>
      <div class="navItemBox">
        <template v-for="(item, index) in pageInfo.secondPovertyModuleDtoList">
          <span :class="[
              'navItem',
              index + pageInfo.secondModuleDtoList.length + 1 == chooseIndex
                ? 'active'
                : ''
            ]" @click="
              changeIndex(index, 'secondPovertyModuleDtoList');
              chooseIndex = index + pageInfo.secondModuleDtoList.length + 1;
            ">{{ item.moduleTitle }}</span>
          <span class="line" v-if="index != pageInfo.secondPovertyModuleDtoList.length - 1"></span>
        </template>
      </div>
    </div>
    <!-- 过滤条件 -->
    <div class="navbarBox">
      <el-popover placement="bottom" trigger="hover" v-for="(item, index) in searchList" :key="index" :disabled="index == 0 || index == 2">
        <div class="popBox" v-if="index == 1">
          <div class="popBox_top">
            目前所在：<span style="color:#333">{{ LocationPCity }}</span>
          </div>
          <div class="popBox_listBox">
            <span :class="[
                'popBox_item',
                queryParams.placeCityName == item ? 'popItemActive' : ''
              ]" v-for="(item, index) in cityList" :key="index" @click="changeTab('placeCityName', item)">{{ item }}</span>
          </div>
        </div>
        <div class="popBox" v-if="index == 3">
          <span :class="[
              'popBox_item',
              index === queryParams.sortByMarketPrice ? 'popItemActive' : ''
            ]" :style="{
              border: 'none',
              margin: index == 0 ? '0 0 12px 0' : '0'
            }" v-for="(item, index) in priceSortList" :key="index" @click="changeTab('sortByMarketPrice', index)">{{ item }}</span>
        </div>
        <div slot="reference" :class="['navBoxItem', chooseType == index ? 'searchActive' : '']" :style="
            index == 3 && queryParams.sortByMarketPrice !== ''
              ? 'width:140px'
              : ''
          " @click="changeType(index)">
          <span>{{
            queryParams.sortByMarketPrice === "" && index == 3
              ? "价格"
              : item.name
          }}</span>
        </div>
      </el-popover>
      <div :class="['priceRange', isPriceFocus ? 'priceFocus' : '']">
        <input type="text" class="priceIpt" placeholder="¥" @focus="onPriceFocus" @blur="onPriceBlur" v-model="marketPriceMin" /><span style="margin:0 3px;">-</span><input type="text" class="priceIpt" placeholder="¥" @focus="onPriceFocus" @blur="onPriceBlur" v-model="marketPriceMax" /><el-button class="priceConfirmBtn" type="primary" @click="confirmPrice">
          确认</el-button>
      </div>
    </div>
    <div class="main">
      <!-- 商品列表 -->
      <div class="mainList" v-for="(item, index) in goodsList" :key="index" @click="gotoDetails(item.id)">
        <div class="floor-imgBox">
          <img :src="item.thumb" alt="" class="mainList_img" />
          <img class="tag-img" :src="
              item.helpPoor == 0
                ? ''
                : item.helpPoor == 1
                ? '../../../static/image/helpPoor.png'
                : item.helpPoor == 2
                ? '../../../static/image/832.png'
                : item.helpPoor == 3
                ? '../../../static/image/cooperation.png'
                : item.helpPoor == 4
                ? '../../../static/image/characteristic.png'
                : item.helpPoor == 5
                ? '../../../static/image/support.png'
                : item.helpPoor == 6
                ? '../../../static/image/helpDisabled.png'
                : item.helpPoor == 7
                ? '../../../static/image/veterans.png'
                : ''
            " />
        </div>
        <div class="mainList_body">
          <span style="display: flex">
            <span class="mainList_text1">{{ item.title }}</span></span>
          <!-- <span class="mainList_text2">{{ item.supplierName }}</span> -->
          <!-- <div class="tagBox">
            <div
              class="tagList"
              v-for="(it, ind) in item.tagInfoPcList"
              :key="ind"
            >
              {{ it }}
            </div>
          </div> -->
          <div class="mainList_price">
            <div class="mainList_priceL">
              <span class="mainList_text3"><span style="font-size: 12px">￥</span>{{ item.intervalPriceList[0].price.toFixed(2) }}</span><span class="mainList_text4" v-if="item.pcProductPrice>=item.intervalPriceList[0].price">￥{{ item.pcProductPrice.toFixed(2) }}</span>
            </div>
            <!-- item.pcMinBuyCount
                  ? item.pcMinBuyCount == 1
                  : item.minBuyCount == 1 -->
            <button class="mainList_btn" v-if="item.intervalPriceList[0].startNum==1">
              一{{ item.unit }}起订
            </button>
            <button class="minNumBox" v-else>
              <!-- item.pcMinBuyCount ? item.pcMinBuyCount : item.minBuyCount -->
              起订量：{{
                item.intervalPriceList[0].startNum
              }}{{ item.unit }}
            </button>
          </div>
          <!-- <div class="mainList_shopCar" @click.stop="nothing()">
            <div class="mainList_shopCarL">
              <input
                type="text"
                class="mainList_shopCarNum"
                oninput="value=value.replace(/[^\d]/g,'')"
                v-model.number="item.num"
              />
          
              <div class="mainList_btnBox">
                <button
                  class="mainList_shopCarAdd"
                  style="transform: rotate(180deg)"
                  @click.stop="addNum(index)"
                >
                  <i class="iconfont">&#xe624;</i>
                </button>
                <button
                  class="mainList_shopCarAdd"
                  @click.stop="reduceNum(index)"
                >
                  <i class="iconfont">&#xe624;</i>
                </button>
              </div>
            </div>
            <button
              class="mainList_shopCarBtn"
              @click.stop="addShopCar(index, item)"
            >
              加入购物车
            </button>
          </div> -->
          <span class="mainList_tip" v-show="numList[index]">采购数量须大于最小起订量</span>
        </div>
      </div>
      <el-empty style="margin: 0 auto" description="暂无数据" v-if="goodsList.length == 0"></el-empty>
    </div>
    <!-- 分页 -->
    <div class="pagination" v-if="pageInfo">
      <el-pagination background @current-change="handleCurrentChange" :current-page="current" layout=" prev, pager, next,total, jumper" :total="total" :page-size="limit">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { doGet } from "../common/HttpHelper.js";
import { httpConfig } from "../common/config.js";
export default {
  data() {
    return {
      pageInfo: "",
      bannerId: this.$route.query.bannerId,
      peopleId: this.$cookies.isKey("peopleId")
        ? this.$cookies.get("peopleId")
        : "-1",
      chooseIndex: 0,
      numList: [false, false, false, false, false, false, false, false], //商品是否显示tip提示
      shopCarNum: 0, //商品选择数量
      current: 1, //当前页数
      total: 0, //总条数
      limit: 16, //每页显示几条
      goodsList: [], //商品列表
      shopCar: [], //购物车列表
      key: "secondModuleDtoList",
      cityList: [], //产地列表
      LocationPCity: "定位中", //当前城市
      marketPriceMin: "", //价格下限
      marketPriceMax: "", //价格上限
      priceSortList: ["价格从低到高", "价格从高到低"],
      queryParams: {
        marketPriceMin: "", //价格下限
        marketPriceMax: "", //价格上限
        placeCityName: "", //产地名称
        sortBySales: "", // 传1按销量降序排列，想取消就不传值
        sortByMarketPrice: "", //传1按销售额降序，传0按销售额升序
        pcCategoryId: this.$route.query.pcCategoryId,
      }, //查询参数
      chooseType: 0,
      isPriceFocus: false, //价格输入框是否获取焦点
    };
  },
  computed: {
    searchList: function () {
      return [
        { name: "全部", value: "" },
        { name: "产地", value: "" },
        { name: "销量", value: "" },
        {
          name: this.priceSortList[
            this.queryParams.sortByMarketPrice === ""
              ? 0
              : this.queryParams.sortByMarketPrice
          ],
          value: "",
        },
      ];
    },
  },
  watch: {
    $route(to, from) {
      if (to.path == from.path && to.query != from.query) {
        this.bannerId = this.$route.query.bannerId; //分类id
        this.queryParams = this.$options.data.call(this).queryParams;
        this.chooseType = this.$options.data.call(this).chooseType;
        this.marketPriceMin = this.$options.data.call(this).marketPriceMin;
        this.marketPriceMax = this.$options.data.call(this).marketPriceMax;

        this.getCity();
        this.getInfo(); //获取商品列表
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    if (to.name == "商品详情") {
      if (!from.meta.keepAlive) {
        from.meta.keepAlive = true;
      }
      next();
    } else {
      from.meta.keepAlive = false;
      to.meta.keepAlive = false;
      this.$destroy();
      next();
    }
  },
  mounted() {
    this.getInfo(); //获取基本信息
    this.getCity();
  },
  methods: {
    changeType(index) {
      if (index == 0) {
        this.chooseType = 0;
        this.queryParams = this.$options.data.call(this).queryParams;
        this.marketPriceMin = this.$options.data.call(this).marketPriceMin;
        this.marketPriceMax = this.$options.data.call(this).marketPriceMax;
        this.getList(
          this.pageInfo[this.key][
            this.key == "secondPovertyModuleDtoList"
              ? this.chooseIndex - this.pageInfo.secondModuleDtoList.length - 1
              : this.chooseIndex
          ].id,
          1
        );
      } else if (index == 2) {
        this.queryParams.sortBySales =
          this.queryParams.sortBySales == 1 ? "" : 1;
        this.chooseType = this.queryParams.sortBySales == 1 ? 2 : null;
        this.queryParams.sortByMarketPrice =
          this.queryParams.sortBySales == 1
            ? ""
            : this.queryParams.sortByMarketPrice;
        this.getList(
          this.pageInfo[this.key][
            this.key == "secondPovertyModuleDtoList"
              ? this.chooseIndex - this.pageInfo.secondModuleDtoList.length - 1
              : this.chooseIndex
          ].id,
          1
        );
      }
    },
    changeTab(key, value) {
      this.queryParams[key] = value;
      if (this.chooseType == 0) {
        this.chooseType = null;
      }
      if (key == "sortByMarketPrice") {
        this.chooseType = 3;
        this.queryParams.sortBySales = "";
      }
      this.getList(
        this.pageInfo[this.key][
          this.key == "secondPovertyModuleDtoList"
            ? this.chooseIndex - this.pageInfo.secondModuleDtoList.length - 1
            : this.chooseIndex
        ].id,
        1
      );
    },
    /**
     * 价格输入框获取焦点
     */
    onPriceFocus() {
      this.isPriceFocus = true;
    },
    /**
     * 价格输入框失去焦点
     */
    onPriceBlur() {
      this.isPriceFocus = false;
    },
    confirmPrice() {
      this.queryParams.marketPriceMin = this.marketPriceMin;
      this.queryParams.marketPriceMax = this.marketPriceMax;
      this.chooseType = this.queryParams.sortBySales == 1 ? 2 : null;
      this.getList(
        this.pageInfo[this.key][
          this.key == "secondPovertyModuleDtoList"
            ? this.chooseIndex - this.pageInfo.secondModuleDtoList.length - 1
            : this.chooseIndex
        ].id,
        1
      );
    },
    getCity() {
      const geolocation = new BMapGL.Geolocation();
      var _this = this;
      geolocation.getCurrentPosition(
        function (position) {
          let city = position.address.city; //获取城市信息
          let province = position.address.province; //获取省份信息
          _this.LocationPCity = city.substring(0, city.length - 1);
        },
        function (e) {
          _this.LocationPCity = "定位失败";
        },
        { provider: "baidu" }
      );
    },
    /**
     * 查询分类下的产地
     */
    getPlaceCity(id) {
      var data = {
        moduleId: id,
      };
      var that = this;
      doGet(
        httpConfig.Category.findPlaceCityNameBySecondMoudleIdUrl,
        data,
        function (res) {
          if (res.flag) {
            that.cityList = res.data;
          } else {
            that.$message.warning(res.message);
          }
        }
      );
    },
    /**
     * 获取基本信息
     */
    getInfo() {
      var data = {
        bannerId: this.bannerId,
      };
      var that = this;
      doGet(httpConfig.Cooperation.getInfo, data, function (res) {
        if (res.flag) {
          that.pageInfo = res.data;
          if (that.pageInfo.secondModuleDtoList.length > 0) {
            that.getList(
              that.pageInfo[that.key][
                that.key == "secondPovertyModuleDtoList"
                  ? that.chooseIndex -
                    that.pageInfo.secondModuleDtoList.length -
                    1
                  : that.chooseIndex
              ].id,
              1
            );
          }
        } else {
          that.$message.warning(res.message);
        }
      });
    },
    /**
     * 获取商品列表
     */
    getList(id, val) {
      var data = {
        pn: val - 1,
        ps: this.limit,
        moduleId: id,
      };
      Object.assign(data, this.queryParams);
      var that = this;
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      doGet(
        httpConfig.Cooperation.getListUrl,
        data,
        function (res) {
          that.goodsList = JSON.parse(JSON.stringify(res.data.rows));
          // that.goodsList.forEach((item) => {
          //   item["num"] = 0;
          // that.shopCar.forEach((x) => {
          //   if (x.id === item.id) {
          //     item.num = x.num;
          //   }
          // });
          // });
          that.total = res.data.total;
          that.current = val;
          loading.close();
          that.getPlaceCity(id); //查询分类下的产地
        },
        function (res) {}
      );
    },
    changeIndex(index, key) {
      this.key = key;
      this.queryParams.placeCityName =
        this.$options.data.call(this).queryParams.placeCityName;
      this.getList(this.pageInfo[key][index].id, 1);
    },
    /**
     * 切换分页
     */
    handleCurrentChange(val) {
      this.numList = [false, false, false, false, false, false, false, false];
      var index =
        this.chooseIndex >= this.pageInfo.secondModuleDtoList.length
          ? this.chooseIndex - this.pageInfo.secondModuleDtoList.length - 1
          : this.chooseIndex;

      this.getList(this.pageInfo[this.key][index].id, val);
    },
    /**
     * 增加数量
     */
    addNum(index) {
      this.$set(this.goodsList[index], "num", this.goodsList[index].num + 1);
      this.$set(this.goodsList, index, this.goodsList[index]);
      if (
        this.goodsList[index].num >=
        // (this.goodsList[index].pcMinBuyCount
        //   ? this.goodsList[index].pcMinBuyCount
        //   : this.goodsList[index].minBuyCount)
        this.goodsList[index].intervalPriceList[0].startNum
      ) {
        this.numList[index] = false;
      }
    },
    /**
     * 减少数量
     */
    reduceNum(index) {
      if (this.goodsList[index].num > 0) {
        this.$set(this.goodsList[index], "num", this.goodsList[index].num - 1);
        this.$set(this.goodsList, index, this.goodsList[index]);
      }
    },
    /**
     * 加入购物车
     */
    addShopCar(index, item) {
      if (this.$cookies.get("peopleId")) {
        if (
          this.goodsList[index].num <
          // (item.pcMinBuyCount ? item.pcMinBuyCount : item.minBuyCount)
          item.intervalPriceList[0].startNum
        ) {
          this.$set(this.numList, index, true);
        } else {
          this.$set(this.numList, index, false);
          var data = {
            thumb: item.thumb,
            title: item.title,
            supplierName: item.supplierName,
            wholesalePrice: item.wholesalePrice,
            pcProductPrice: item.pcProductPrice,
            num: item.num,
            id: item.id,
            isSelected: true,
            spec: item.spec,
            unit: item.unit,
          };
          if (this.$cookies.isKey("shopCar")) {
            var shopCar = JSON.parse(JSON.stringify(this.shopCar));
            for (var i = 0; i < shopCar.length; i++) {
              if (data.id == shopCar[i].id) {
                shopCar.splice(i, 1);
                i--;
              }
            }
            shopCar.push(data);
            this.$cookies.set("shopCar", JSON.stringify(shopCar));
          } else {
            this.$cookies.set("shopCar", JSON.stringify([data]));
          }
          this.$message({
            type: "success",
            message: "加入购物车成功",
          });
          this.shopCar = JSON.parse(this.$cookies.get("shopCar"))
            ? JSON.parse(this.$cookies.get("shopCar"))
            : [];
          this.shopCarNum = 0;
          this.shopCar.forEach((x) => {
            this.shopCarNum += x.num; //计算购物车商品总数
          });
          this.$store.commit("saveShopCarNum", this.shopCarNum);
        }
      } else {
        this.$message.warning("请先登录");
        this.$router.push("/login");
      }
    },
    /**
     * 返回顶部
     */
    gotoTop() {
      let top = document.documentElement.scrollTop || document.body.scrollTop;
      // 实现滚动效果
      const timeTop = setInterval(() => {
        document.body.scrollTop =
          document.documentElement.scrollTop =
          top -=
            50;
        if (top <= 0) {
          clearInterval(timeTop);
        }
      }, 10);
    },
    /**
     * 商品详情
     */
    gotoDetails(id) {
      this.$router.push({ path: "/goodsInfo", query: { id: id } });
    },
    /**
     * 无效事件
     */
    nothing() {},
  },
};
</script>

<style scoped>
@import "../../assets/css/helpPoor";
</style>



// WEBPACK FOOTER //
// src/components/page/helpPoor.vue